(() => {
  const openInstantly = (collapsible, details) => {
    details.setAttribute('open', '');
    details.classList.add('is-open');
    collapsible.isAnimating = false;

    if (collapsible.contentWrapper) {
      collapsible.contentWrapper.style.cssText = 'height: auto';
    }

    if (collapsible.contentEl) {
      collapsible.contentEl.style.transform = 'translateY(0)';
    }
  };

  const closeInstantly = (collapsible, details) => {
    details.classList.remove('is-open');
    details.removeAttribute('open');
    collapsible.isAnimating = false;

    if (collapsible.contentWrapper) {
      collapsible.contentWrapper.style.cssText = 'height: 0';
    }

    if (collapsible.contentEl) {
      collapsible.contentEl.style.transform = 'translateY(16px)';
    }
  };

  const openFaqByHash = () => {
    const hash = window.location.hash.slice(1);
    if (!hash) return;

    const target = document.getElementById(hash);
    if (!target?.classList.contains('accordion')) return;

    const collapsible = target.querySelector('collapsible-details');
    const details = collapsible?.querySelector('details') || target.querySelector('details');
    if (!details || !collapsible) return;

    const section = target.closest('.section-faq');
    section?.querySelectorAll('collapsible-details').forEach((element) => {
      if (element === collapsible) return;
      if (element.detailsEl?.hasAttribute('open')) {
        closeInstantly(element, element.detailsEl);
      }
    });

    openInstantly(collapsible, details);

    requestAnimationFrame(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  const init = () => {
    openFaqByHash();
    window.addEventListener('hashchange', openFaqByHash);
  };

  if (window.customElements?.whenDefined) {
    customElements.whenDefined('collapsible-details').then(init);
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
